import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Bolt as BoltIcon } from '@mui/icons-material';

/**
 * Small "Dynamic" chip shown when a flow has a data-exchange endpoint
 * configured. On-brand (WhatsApp green via the primary palette) and subtle.
 */
const DynamicFlowChip = ({ size = 'small', sx }) => (
  <Tooltip title="This flow exchanges data with a configured endpoint">
    <Chip
      label="Dynamic"
      size={size}
      color="primary"
      variant="outlined"
      icon={<BoltIcon />}
      sx={sx}
    />
  </Tooltip>
);

export default DynamicFlowChip;
